import { oauthTokenSelector } from 'selectors/app'

import integrationApi from '../../api'
import { ALL_REPOSITORIES } from '../constants'
import gitHubGraphQl from '../gitHubGraphQl'
import {
  FETCH_INSTALLS_ERROR,
  FETCH_INSTALLS_REQUEST,
  FETCH_INSTALLS_SUCCESS,
} from '../types'

const QUERY_ORGANIZATIONS = `
  query {
    viewer {
      __typename
      avatarUrl
      databaseId
      id
      isViewer
      login
      name
      organizations(first:100) {
        nodes {
          __typename
          avatarUrl
          databaseId
          id
          login
          name
          viewerCanAdminister
          viewerIsAMember
        }
      }
      
    }
  }
`

export default function doFetchGitHubInstalls() {
  return (dispatch, getState) => {
    const token = oauthTokenSelector(getState())
    dispatch({
      type: FETCH_INSTALLS_REQUEST,
      meta: { loading: { [ALL_REPOSITORIES]: true } },
    })
    Promise.all([
      integrationApi
        .get(
          token,
          'proxy/github/user/installations',
          {},
          { Accept: 'application/vnd.github.machine-man-preview+json' }
        )
        .then(({ json: { installations } }) => {
          return Promise.all(
            installations.map(installation => {
              const { id } = installation
              return integrationApi
                .get(
                  token,
                  `proxy/github/user/installations/${id}/repositories`,
                  {},
                  {
                    Accept: 'application/vnd.github.machine-man-preview+json',
                  }
                )
                .then(({ json: { repositories } }) => {
                  return {
                    ...installation,
                    repositories,
                  }
                })
            })
          )
        }),
      gitHubGraphQl(token, QUERY_ORGANIZATIONS),
    ])
      .then(
        installs =>
          new Promise(resolve => setTimeout(() => resolve(installs), 10000))
      )
      .then(
        ([
          installs,
          {
            data: {
              viewer,
              viewer: {
                organizations: { nodes: organizations },
              },
            },
          },
        ]) => {
          const installsWithOutRepositories = installs.map(install => ({
            ...install,
            repositories: install.repositories.map(
              ({ node_id: nodeId }) => nodeId
            ),
          }))
          const allRepositories = installs.reduce(
            (result, { repositories }) => {
              result.push(
                ...repositories.map(repository => ({
                  ...repository,
                  __typename: 'Repository',
                  owner: {
                    ...repository.owner,
                    id: repository.owner.node_id,
                  },
                  id: repository.node_id,
                }))
              )
              return result
            },
            []
          )
          dispatch({
            type: FETCH_INSTALLS_SUCCESS,
            meta: { loading: { [ALL_REPOSITORIES]: false } },
            payload: {
              installs: installsWithOutRepositories,
              nodes: [viewer, ...organizations, ...allRepositories],
            },
          })
        }
      )
      .catch(error => {
        dispatch({
          error: true,
          payload: error,
          meta: { loading: { [ALL_REPOSITORIES]: false } },
          type: FETCH_INSTALLS_ERROR,
        })
      })
  }
}
